import { useQuery } from '@tanstack/react-query';

import { useUser } from '@/features/auth/hooks/use-user';
import { getProfileId } from '@/features/org/api/get-profile-id';
import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';

export const useProfileId = () => {
  const { data: user } = useUser();
  const orgId = useCurrentOrgId();
  return useQuery({
    queryKey: ['profileId', user?.id, orgId],
    queryFn: () => getProfileId(user?.id ?? '', orgId?.toString() ?? ''),
    enabled: !!user?.id && !!orgId,
  });
};
